// KY_22.05 start //
setTimeout(function (){
    $(".js-featured-review").on('click', function() {
        const sectionId = $(this).attr('data-section-id')
        if($(`#${sectionId}`).length > 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(`#${sectionId}`).offset().top - 150
            }, 2000);
        }
    });
},500)

function wssGetProductFixedBlock($from) {
    var $action = $from.closest('.card-action');
    var $block = $action.find('.product-fixed-block');
    if (!$block.length) {
        $block = $action.data('productFixedPortal');
    }
    if (!$block.length) {
        $block = $from.closest('.product-item').find('.product-fixed-block').first();
    }
    return $block;
}

function wssCloseProductFixedBlock($block) {
    if (!$block || !$block.length) {
        return;
    }
    $block.removeClass('active');
    var $parent = $block.data('restore-parent');
    if ($parent && $parent.length) {
        $block.appendTo($parent);
        $block.removeData('restore-parent');
    }
    $('body').removeClass('no-scroll');
}

$(document).on("click", ".js-product-fixed-button-toggle", function() {
    var $block = wssGetProductFixedBlock($(this));
    if (!$block.length) {
        return;
    }
    var $action = $(this).closest('.card-action');
    if ($block.parent()[0] !== document.body) {
        $block.data('restore-parent', $block.parent());
        $action.data('productFixedPortal', $block);
        $block.appendTo('body');
    }
    $block.addClass('active');
    $('body').addClass('no-scroll');
});
$(document).on("click", ".product-fixed-block .overflow", function () {
    wssCloseProductFixedBlock($(this).closest('.product-fixed-block'));
});
$(document).on("click", ".product-fixed-block form .button", function() {
    wssCloseProductFixedBlock($(this).closest('.product-fixed-block'));
});

// KY_22.05 end //